import styled from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { BoxTitle } from '../boxTitle/boxTitle.component';
import { Image } from '../image/image.component';

import { ContentSectionProps, PriceProps, PricesProps } from './artworkBiddingBox.types';

export const Container: StyledComponent<'div'> = styled.div``;

export const InnerContainer: StyledComponent<'div'> = styled.div`
  padding: 24px;
  border: 1px solid ${Color.Gray300};
`;

export const TopSection: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;
  border-bottom: 1px solid ${Color.Gray300};
  flex-wrap: wrap;
`;

export const AuctionDeadline: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
  display: flex;
  align-items: center;
`;

export const ContentSection: StyledComponent<'div', ContentSectionProps> = styled.div<ContentSectionProps>`
  padding-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${({ $hasPaddingBottom }: ContentSectionProps): string => $hasPaddingBottom ? '24px' : '0'};
`;

export const Price: StyledComponent<'div', PriceProps> = styled.div<PriceProps>`
 display: flex;
 flex-wrap: wrap;
 justify-content: flex-end;
 font-weight: ${({ $withBoldedFont }: PriceProps): string => $withBoldedFont ? FontWeight.Medium : FontWeight.Light};

  & + & {
    margin-top: 4px;
  }

  @media ${Breakpoint.Mobile} {
    justify-content: space-between;
  }
`;

export const PriceItem: StyledComponent<'span'> = styled.span`
  font-size: 16px;
  line-height: 22px;
  text-align: right;
`;

export const InnerPriceItem: StyledComponent<typeof PriceItem> = styled(PriceItem)`
  margin-left: 5px;
  white-space: nowrap;
`;

export const Prices: StyledComponent<'div', PricesProps> = styled.div<PricesProps>`
  display: flex;
  flex-direction: column;
  margin-left: 10px;

  @media ${Breakpoint.Mobile} {
    margin-left: 0;
    align-items: space-between;
    justify-content: center;
    width: 100%;
    margin-bottom: ${({ $withMarginBottom }: PricesProps): string => $withMarginBottom ? '20px' : '0'};
  }
`;

export const BottomContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 24px;
  border-top: 1px solid ${Color.Gray300};

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
  }
`;

export const ImageWithBoxTitle: StyledComponent<'div'> = styled.div`
  display: flex;
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  object-fit: cover;
  width: 100px;
  height: 100px;
  margin-right: 16px;
  flex-shrink: 0;
`;

export const StyledBoxTitle: StyledComponent<typeof BoxTitle> = styled(BoxTitle)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const BadgesContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-right: 10px;
  margin-bottom: 8px;
`;
